import { render, staticRenderFns } from "./WBtnExport.vue?vue&type=template&id=9731036e&scoped=true&"
import script from "./WBtnExport.vue?vue&type=script&setup=true&lang=js&"
export * from "./WBtnExport.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9731036e",
  null
  
)

export default component.exports